<template>
  <v-container class="fitContainer mt-2">
    <v-row dense align="start" justify="center" class="fitContainer pa-1">
      <template v-for="(item, index) in itemsSorted()">
        <v-col
          v-if="item.available"
          lg="3"
          md="3"
          sm="3"
          cols="6"
          xs="12"
          class="hTerco roundedItem"
          :style="{'cursor' : 'pointer'}"
          :key="name+'_'+index"
          @click="link(item)"
        >
          <div class="elevation-3 fill-height roundedItem" :style="{'position': 'relative'}">
            <div
              :style="{
                'zIndex': '1',
                'width': '100%',
                'position': 'absolute',
                'border-radius': '5px 5px 0px 0px'
              }"
              class="pl-2 py-2 ma-0 tertiary font-weight-bold body-2 elevation-0 black--text"
            >{{item.titulo}}</div>

            <v-img
              :src="'img/produtos/'+item.imgname"
              class="fill-height roundedItem"
              aspect-ratio="1"
            />
          </div>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import store from "../../store/store";
import XippAuthService from "@/services/auth/XippAuthService";
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    async loadJWTToken() {
      this._xippAuthService = new XippAuthService();
      
      if(this.$route.query && this.$route.query.token) {
        const sessionKey = "access_token";
        localStorage.setItem(sessionKey, this.$route.query.token);
        await this._xippAuthService.GetTokenFull()
          .then((response) => {
            if(response && response.data) {
              localStorage.setItem(sessionKey, response.data.token);
            }
          });
      }
    },
    itemsSorted() {
      return this.items;
    },
    async link(item) {
      if (!item.available) {
        store.commit("showmsg", {
          text: "Não disponvivel no momento",
          type: "warning",
        });
      } else {
        var origin = this.$route.query.origin;
        var personType = this.$route.query.personType;

        await this.loadJWTToken();

        this.$util.link(
          "comprarProduto",
          { id: item.id },
          { origin: origin, personType: personType }
        );
      }
    },
  },
};
</script>


